<template>
  <student-majors :studentId="profile.id" />
</template>
<script>
import { mapGetters } from 'vuex'
import StudentMajors from '@/modules/student/class/Majors.vue'
export default {
  props: {
    student: Object
  },
  components: {
    StudentMajors
  },
  computed: {
    ...mapGetters('auth', ['profile'])
  }
}
</script>

<style>
</style>
